import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-model-dialog',
  templateUrl: './model-dialog.component.html',
  styleUrls: ['./model-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class ModelDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ModelDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup;
  type: string = 'model';
  headline: string;
  content: string;
  confirm: string;
  placeholder: string;
  required = Validators.required;

  ngOnInit() {
    if (this.data) {
      this.headline =
        this.data.headline || 'Reason for switching Investment Model';
      this.content = this.data.content || '';
      this.placeholder = this.data.placeholder || '';
      this.confirm = this.data.confirm || 'Save';
      this.type = this.data.type || 'model';
      this.required =
        this.data.commentRequired === false ? null : this.required;
    }

    const formGroup = {};
    formGroup['reason'] = new FormControl('', this.required);
    this.form = new UntypedFormGroup(formGroup);
  }

  cancel() {
    this.dialogRef.close({ data: 'cancel' });
  }

  save() {
    if (this.form.valid) {
      this.dialogRef.close({ data: this.form.get('reason').value });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }
}
